import { observer } from 'mobx-react-lite'
import { type TeamListViewModel } from '@/features/iam/teams/TeamListViewModel'
import { TeamList } from '@/features/iam/teams/components/TeamList'
import { TeamItemContainer } from '@/features/iam/teams/components/TeamItem/TeamItemContainer'

export interface TeamListContainerProps {
  vm: TeamListViewModel
  onCreateTeamRequest: () => void
  showCreateAction: boolean
  activeTeamSlug: string | undefined
}

export const TeamListContainer = observer(function TeamListContainer({
  vm,
  onCreateTeamRequest,
  showCreateAction,
  activeTeamSlug,
}: TeamListContainerProps) {
  return (
    <TeamList
      searchText={vm.searchText}
      onSearchTextChange={vm.setSearchText}
      onCreateTeamRequest={onCreateTeamRequest}
      showCreateAction={showCreateAction}
    >
      {vm.teamItems.map((teamItem) => (
        <TeamItemContainer
          key={teamItem.team.id || ''}
          vm={teamItem}
          active={teamItem.team.slug === activeTeamSlug}
        />
      ))}
    </TeamList>
  )
})
